import { useState } from 'react';

import { Box } from '@mui/material';

import { BuyerLeadActivityEmailForm } from '@modules/_shared/components/buyer-lead/BuyerLeadActivityEmailForm';
import { BUYER_LEAD_FEED } from '@modules/_shared/components/buyer-lead/buyerLeadQueries';
import { ActivityFeed } from '@modules/_shared/components/feed-v2/ActivityFeed';
import { useScrollableAncestor } from '@modules/_shared/components/feed-v2/useScrollableAncestor';

type Props = {
  buyerLeadId: string;
  phoneNumber?: string | null;
  readOnly?: boolean;
};

export const BuyerLeadFeedV2 = ({
  buyerLeadId,
  phoneNumber,
  readOnly = false,
}: Props) => {
  const [anchor, setAnchor] = useState<HTMLDivElement | null>(null);
  const scrollParent = useScrollableAncestor(anchor);

  return (
    <Box ref={setAnchor}>
      <ActivityFeed
        parentType="BuyerLead"
        parentId={buyerLeadId}
        query={BUYER_LEAD_FEED}
        variables={{ buyer_lead_id: buyerLeadId, limit: 200 }}
        scrollParent={scrollParent}
        fallbackPhoneNumber={phoneNumber}
        EmailFormComponent={BuyerLeadActivityEmailForm}
        disabled={readOnly}
      />
    </Box>
  );
};
